import React from "react";
import Sidebar from "./sidebar";
import Header from "./header";

function DashboardLayout({ children }) {
  return (
    <div style={{ display: "flex" }}>
      {/* Sidebar */}
      {/* <Sidebar /> */}

      <div style={{ flex: 1 }}>
        {/* Top Header */}
        {/* <Header /> */}

        {/* Page Content */}
        <div style={{ padding: "20px" }}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default DashboardLayout;
